
interface WebpackFileEntry {
	exports: any;
}

/**
 * getWebpackFile("pixi.js")
 * @param fileName
 */
export function getWebpackFile(fileName: string) {
	// hacky
	const allModules: { [file: string]: WebpackFileEntry } = (window as any).webpackChunkEngin3[0][1];

	return Object.entries(allModules)
		.filter(entry => entry[0].toLowerCase().includes(fileName.toLowerCase()))
		.map(entry => {
			return { file: entry[0], exports: entry[1].exports };
		})[0];
}